<template>
  <div class="contact-us">
    <h2>联系我们</h2>
    <section>
      <p>高绩（<em>上海高绩数据科技有限公司</em>）是国内领先的高等教育数据生产与解决方案咨询机构。高绩建设了“大学360度数据监测平台”“学科发展水平数据监测平台”“专业建设水平数据监测平台”等矩阵式的高等教育数据监测平台，是权威排名的专属数据提供机构。</p>
      <ul>
        <li>
          上海高绩数据科技有限公司
        </li>
        <li>
          电话：021-64315006
        </li>
        <li>
          邮箱：support@gaojidata.com
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { updatePassword } from '@/api/profile'
import { mapActions } from 'vuex'
export default {
  name: 'contact_us',
  data() {
    return {

    }
  }
}
</script>
<style lang="scss">
.contact-us {
  text-align: left;
  font-size: 14px;
  color: #343438;
  word-break: break-all;
  font-family: 'Microsoft YaHei';
  h2{
    height: 32px;
    line-height: 32px;
    margin: 9px 0;
    font-size: 20px;
    color: #434345;
    margin-bottom: 8px;
  }
  section{
    line-height: 22px;
    p{
      margin-bottom: 14px;
      text-align: justify;
      em{
        font-style: initial;
        font-weight: 600;
      }
    }
    ul{
      li {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
